import { INTEGRITY_ITEMS, INTEGRITY_DIMS } from "./questionBank.js";
import { scoreIntegrity, IG_NORMS, IG_RISK_BANDS, IG_DIM_THRESHOLDS } from "./scoring.js";
export { INTEGRITY_DIMS, IG_NORMS, IG_RISK_BANDS, IG_DIM_THRESHOLDS };

const IntegrityScreener = {
  id:"integrity", name:"Integrity Screener", shortName:"Integrity",
  icon:"🔒", color:"#1d4ed8", bg:"#eff6ff",
  description:"30-item overt integrity screener grounded in Sackett's overt integrity framework and the HEXACO Honesty-Humility factor. Identifies risk indicators for theft, dishonesty, records falsification, confidentiality breaches and counterproductive work behaviour. Delivers a risk score plus specific flag indicators for structured interview follow-up.",
  desc:"30 items · 12 minutes · Risk score + flag indicators · Trust-critical roles",
  publisher:"AXIS360 Express", version:"1.0",
  itemCount:30, items:30, timeLimit:12, time:"12 min", timeEstimate:"12 minutes",
  format:       "likert", scaleType:"likert-5", isScreener:true, isExpress:true, pricingTier:"volume", creditCost:20,
    pagesOf:15, totalPages:2,
  predicts:["Counterproductive work behaviour","Asset misappropriation risk","Confidentiality breach likelihood","Absenteeism and reliability"],
  questions: INTEGRITY_ITEMS,
  dims: INTEGRITY_DIMS,
  score(answers){ return scoreIntegrity(answers); },
  nineboxAxes:{ x:{label:"Integrity",scaleIds:["integrity"]}, y:{label:"Integrity",scaleIds:["integrity"]} },
};
export default IntegrityScreener;
